import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FuseUtils } from '@fuse';
import { Toolbar, AppBar, InputAdornment, Dialog, TextField, DialogContent, DialogActions, Button, Icon, IconButton, MenuItem, Typography, Input, InputLabel, FormHelperText, FormControl } from 'material-ui';
import { bindActionCreators } from 'redux';
import CloseIcon from '@material-ui/icons/Close';
import ReactTable from "react-table";
import classNames from 'classnames';
import Formsy from 'formsy-react';
import { TextFieldFormsy, CheckboxFormsy, SelectFormsy } from '@fuse';
import ExpansionPanel, {
    ExpansionPanelDetails,
    ExpansionPanelSummary,
} from 'material-ui/ExpansionPanel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import axios from 'axios';
import { withAlert } from 'react-alert';
import Loader from "other-components/loader/loader";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Select from 'react-select';
import _ from "lodash";
import {CSVLink, CSVDownload} from 'react-csv';
import printjs from 'print-js';

class pettyCashReport extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading:false,
            tableLoading:false,
            tableColumns: [],
            transactionData: [],
            fromDate: new Date().getFullYear()+"-"+("0"+((new Date().getMonth()+1).toString())).substr(-2)+"-"+("0"+(new Date().getDate().toString())).substr(-2),
            toDate: new Date().getFullYear()+"-"+("0"+((new Date().getMonth()+1).toString())).substr(-2)+"-"+("0"+(new Date().getDate().toString())).substr(-2),
            error: {
                cashBook: '',
                fromDate: null,
                toDate: null
            },
            total: {
            }
        };
    }

    getPettycashCategory = () => {

        this.setState({loading:true});

        axios.get(window.accountServer + '/pettyCash/getPettyCashCategory')
            .then(res => {

                var pettyCashCategories = res.data;

                this.state.tableColumns.push({ Header: "Date",accessor: "DATE"});
                this.state.tableColumns.push({ Header: "Details",accessor: "DESCRIPTION"});
                this.state.tableColumns.push({ Header: "Total",
                                                accessor: "TOTAL",
                                                className: "justify-end",
                                                Footer:  () => (
                                                    <span className="float-right">
                                                    <strong>{this.state.total['total']}</strong>
                                                    </span>
                                                )});
        
                for(let i=0; pettyCashCategories.length>i; i++){

                    if(pettyCashCategories[i].STATUS==1){
                    this.state.tableColumns.push({ Header: pettyCashCategories[i].PETTY_CASH_CATEGORY,
                                                   accessor: pettyCashCategories[i].PETTY_CASH_CATEGORY, 
                                                   className: "justify-end",
                                                   Footer: () => (
                                                    <span className="float-right">
                                                      <strong>{this.state.total[pettyCashCategories[i].PETTY_CASH_CATEGORY]}</strong>
                                                      {/* <strong>{_.sum(_.map(this.state.transactionData['33c']))}</strong> */}
                                                      
                                                    </span>
                                                  )});
                    }
                }
        
                this.state.tableColumns.push({ Header: "Balance",accessor: "BALANCE", className: "justify-end"});

                this.setState({loading:false});
            })

    }

    getPettyCashTransaction = () => {

        if(this.state.error.cashBook == null && this.state.error.fromDate == null && this.state.error.toDate == null){

        this.setState({total:[]}); 
        this.setState({tableLoading:true});
        // this.setState({loading:true});

        var data = {
            id : this.state.pettyCashBook.value,
            fromDate : this.state.fromDate,
            toDate : this.state.toDate
        }

        axios.post(window.accountServer + '/pettyCash/getPettyCashTransaction',data)
            .then(res => {
                console.log('getPettyCashTransaction' , res);

                axios.post(window.accountServer + '/pettyCash/getPettyCashTransactionSum',data)
                .then(res2 => {
                    console.log('getPettyCashTransactionSum' , res2);

                var tmpArry = [];

                for(let i=0; res.data.length>i; i++){

                    

                    let total = 0;
                    let categoryTotal = 0.00;
                    var category = ' ';
                    var date = ' ';

                    if(res.data[i].DATE) date = res.data[i].DATE.substr(0,10);

                    // if(res.data[i].CR > 0) total = res.data[i].CR;
                    // else if(res.data[i].DR > 0) total = res.data[i].DR;
                    if(res.data[i].CR!=null){
                        total = -Math.abs(parseFloat(res.data[i].CR));
                        total = new Intl.NumberFormat().format(total);
                        categoryTotal = parseFloat(res.data[i].CR);
                        //total = parseFloat(total) - parseFloat(total) * 2;
                    }else{
                        total = new Intl.NumberFormat().format(res.data[i].DR);
                        categoryTotal = parseFloat(res.data[i].DR);
                    }
                    
                    category = res.data[i].PETTY_CASH_CATEGORY;

                    var element = {

                        DATE: date,
                        TOTAL: total,
                        DESCRIPTION: res.data[i].DESCRIPTION,
                        BALANCE: new Intl.NumberFormat().format(res.data[i].BALANCE)
                    }

                    element[category] = new Intl.NumberFormat().format(categoryTotal);

                    tmpArry.push(element);
               
                }

                let total = 0;
                
                var tmpArray2 = {...this.state.total};

                for(let n=0; res2.data.length>n; n++){
                   
                    
                   
                    if(res2.data[n].CRAMOUNT!=null){
                        tmpArray2[res2.data[n].PETTY_CASH_CATEGORY] = new Intl.NumberFormat().format(res2.data[n].CRAMOUNT);
                        total = parseFloat(total) - parseFloat(res2.data[n].CRAMOUNT);
                    }
                    else{
                        total = parseFloat(total) + parseFloat(res2.data[n].DRAMOUNT);
                    }

                }

                tmpArray2['total'] = new Intl.NumberFormat().format(total);

                this.setState({total:tmpArray2}
                ,()=>{
                    console.log('state.total',tmpArray2);
                });
                this.setState({transactionData:tmpArry},
                    ()=>{
                        console.log('state.transactionData',tmpArry);
                    });

                this.setState({tableLoading:false});
                // this.setState({loading:false});
            })
            })

        }

        else{

            if(this.state.error.cashBook == ''){
                var tmpArray = {...this.state.error};
            tmpArray['cashBook'] = 'Petty Cash Book Required';
            this.setState({ error: tmpArray });
            }
            else{
                this.setFromDate(null);
            this.setToDate(null);
            }
            
        }

    }

    getBook = () => {

        // this.setState({ loading: true });
        var pettyCashBooks = [];
        // axios.get('http://localhost:5009/pettyCash/getPettyCashBook')
         axios.get(window.accountServer+'/pettyCash/getPettyCashBook')
         .then(response => {

            for (let i = 0; i < response.data.length; i++) {

                if(response.data[i].IS_ACTIVE == 1){

                pettyCashBooks.push({
                    value: response.data[i].ID_LEDGER_ACCOUNT,
                    label: response.data[i].NAME,
                    amount: response.data[i].REIMBURSE_AMOUNT
                });
            }
            }
            this.setState({ pettyCashBooks: pettyCashBooks });
            // this.setState({ loading: false });
         })
    }

    handlePettyCashBook = (selectedOption) => {

        if (selectedOption) {

            this.setState({pettyCashBook: selectedOption});

            var tmpArray = {...this.state.error};
            tmpArray['cashBook'] = null;
            this.setState({ error: tmpArray });
    }

    else{

        this.setState({pettyCashBook: null});
        var tmpArray = {...this.state.error};
        tmpArray['cashBook'] = 'Petty Cash Book Required';
        this.setState({ error: tmpArray });
    }
    }

    setFromDate = (data) => {

     if(data != null)this.setState({fromDate: data.target.value});

     if(new Date(this.state.fromDate).getTime()>new Date(this.state.toDate).getTime()){

        var tmpArray = {...this.state.error};
        if(data == null)tmpArray['fromDate'] = 'From Date cannot be grater than To Date';
        this.setState({ error: tmpArray });
     }
     else{

        var tmpArray = {...this.state.error};
        tmpArray['fromDate'] = null;
        tmpArray['toDate'] = null;
        this.setState({ error: tmpArray });
     }
    }

    setToDate = (data) => {

        if(data != null)this.setState({toDate: data.target.value});

     if(new Date(this.state.fromDate).getTime()>new Date(this.state.toDate).getTime()){

        var tmpArray = {...this.state.error};
        if(data == null)tmpArray['toDate'] = 'To Date cannot be lower than From Date';
        this.setState({ error: tmpArray });
     }
     else{

        var tmpArray = {...this.state.error};
        tmpArray['toDate'] = null;
        tmpArray['fromDate'] = null;
        this.setState({ error: tmpArray });
     }
    }

    printPettyCashTransaction = () => {

        var path = null;

        var data = {
            headerData:{
                pettyCashBook : this.state.pettyCashBook,
                fromDate : this.state.fromDate,
                toDate : this.state.toDate
            },
            transactionData:this.state.transactionData,
            totalData:this.state.total,
            tableColumns:this.state.tableColumns,
        };

        axios.post(window.reportServer+'/pettyCashReport/pdf',data)
         .then(response => {
                path = response.data.path;
                path = window.reportServer+"/" + path;

                const url = path;
                if(response.data.success){
                    window.open(url, '_blank');
                }
                // printjs({ printable: url, type: 'pdf', showModal: true })
            })
    }

    render() {
       
        if (this.state.loading) {
            return (

                <Loader />

            );
        }
        else {

            return (

                <div>
                    <Toolbar className="flex w-full pt-24 px-12">
                        <h2 className="w-full subtitle-color">
                            Petty Cash Report
                    </h2>
                        <div className="w-full p-8 inline-block">
                        <Select
                                        name="pettyCashBook"
                                        placeholder="Search Petty Cash Book"
                                        value={this.state.pettyCashBook}
                                        onChange={this.handlePettyCashBook}
                                        options={this.state.pettyCashBooks}
                                    />
                                    <FormHelperText className="text-red-light">{this.state.error.cashBook}</FormHelperText>
                        </div>
                        <div className="w-full sm:w-1/2 md:w-1/3 p-8 inline-block">
                                    
                            <TextField
                                    type="date"
                                    label="From Date"
                                    value={this.state.fromDate}
                                    onChange={(ev) => {
                                        ev.stopPropagation();
                                        this.setFromDate(ev);
                                    }}
                                />
                                <FormHelperText className="text-red-light">{this.state.error.fromDate}</FormHelperText>
                        </div>
                        <div className="w-full sm:w-1/2 md:w-1/3 p-8 inline-block">
                            
                            <TextField
                                    type="date"
                                    label="To Date"
                                    value={this.state.toDate}
                                    onChange={(ev) => {
                                        ev.stopPropagation();
                                        this.setToDate(ev);
                                    }}
                                />
                                <FormHelperText className="text-red-light">{this.state.error.toDate}</FormHelperText>
                        </div>
                        
                        <div className="px-12">
                            <Button
                                type="button"
                                variant="raised"
                                color="secondary"
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    this.getPettyCashTransaction();
                                }}
                            >
                                View
                    </Button>
                        </div>
                        <div className="px-12">
                            <Button
                                variant="raised"
                                color="default"
                            >
                                Email
                 </Button>
                        </div>
                        <div className="px-12">
                            <Button
                                variant="raised"
                                color="default"
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    this.printPettyCashTransaction();
                                }}
                            >
                                Print
                 </Button>
                        </div>
                        <div className="px-12">
                            
                 <CSVLink data={this.state.transactionData} filename={"pettycash report.csv"} target="_blank">
                 <Button
                                variant="raised"
                                color="default"
                            >
                                Export
                 </Button></CSVLink>
                        </div>
                    </Toolbar>

                    <ReactTable
                        className="-striped -highlight m-12 border-2 border-green-darkest customer-list-margin"
                        getTrProps={() => {
                            return {
                                className: "cursor-pointer",
                            }
                        }}
                        data={this.state.transactionData}
                        loading={this.state.tableLoading}
                        columns={this.state.tableColumns}
                        defaultPageSize={10}
                        noDataText="No Transactions found"
                    />
                </div>
            );
        }
    }

    componentWillMount() {

        this.getPettycashCategory();
        this.getBook();
        }
}


export default withStyles({withTheme: true})(withRouter(connect()(withAlert(pettyCashReport))));


// WEBPACK FOOTER //
// ./src/main/content/accountingReports/pettyCash/pettyCashReport.js